import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { getSwitchDashboard, setSwitchDashboard } from '../storage.service';

export class SwitchDashboardService {
  switchDashboard = new BehaviorSubject(false);

  constructor() {
    this.switchDashboard.next(getSwitchDashboard() || false);
  }

  get switchDashboard$() {
    return this.switchDashboard.asObservable();
  }

  setSwitchDashboard(switchDashboardValue: boolean) {
    this.switchDashboard.next(switchDashboardValue);
    setSwitchDashboard(switchDashboardValue);
  }

  toggleSwitchDashboard() {
    const switchDashboard = !this.switchDashboard.getValue();
    this.switchDashboard.next(switchDashboard);
    setSwitchDashboard(switchDashboard);
  }

  switchDashboardAndStore() {
    this.switchDashboard.next(true);
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/visual/switchDashboard.service.ts